<template>
  <div class="contentBox">
    <navBox :id="navId" :cid="childrenID" ref="navBox"></navBox>
    <div class="content topicBox" v-if="topicType">
      <myHeader></myHeader>
      <div class="organiza-txt" v-if="topiclistType">
        <div class="organiza-title clear">
          <p :class="headID==1?'select':''" @click="headSub('1')">单题</p>
          <p :class="headID==2?'select':''" @click="headSub('2')">多题</p>
          <p style="margin-left: 20px;font-size: 14px;color: #ccc;">{{headID == 1 ? '单题定义：一段对话对应一道题' : '多题定义：一段对话对应多道题'}}</p>
        </div>
        <div class="organiza-form " v-if="headID == 1">
          <div class="organiza-list" v-for="(item,index) in addObj.topics" :key="(index+1)">
            <div class="organiza-item">
              <p>题目{{(index+1)}}</p>
              <!-- <input type="text" v-model="item.topic"> -->
              <button class="btn btn-remove" @click="removeTopic(item,index)">删除</button>
            </div>
            <div class="organiza-item">
              <p>提示语：</p>
              <textarea v-model="item.prompt" placeholder="例如：
conversation is followed by three or moreNow you will hearsome comversationgueshons. Choose the beststion and mark the letter ofthe comreetnversation only one time."></textarea>
            </div>
            <div class="organiza-item">
              <p>题干/选项/答案/解析：</p>
              <textarea v-model="item.topic" 
                placeholder="例如：【1】What will the students be doing at theaquarium?
(A) Helping the aquarium staff
(B) Attending a show on underwater life
(C) Learning how new exhibits are made
(D) Seeig an exhibit on unusual seacreatures
答案：C
解析：解析"></textarea>
            </div>
            <div class="organiza-item">
              <p>听力文本：</p>
              <textarea v-model="item.content" 
                placeholder=""></textarea>
            </div>
          </div>
        </div>
        <div class="organiza-form " v-if="headID == 2">
          <div class="organiza-list" v-for="(item,index) in addObj.topics" :key="(index+1)">
            <div class="organiza-item">
              <p>题目{{(index+1)}}</p>
              <!-- <input type="text" v-model="item.topic"> -->
              <button class="btn btn-remove" @click="removeTopic(item,index)">删除</button>
            </div>
            <div class="organiza-item">
              <p>提示语：</p>
              <textarea v-model="item.prompt" placeholder="例如：
conversation is followed by three or moreNow you will hearsome comversationgueshons. Choose the beststion and mark the letter ofthe comreetnversation only one time."></textarea>
            </div>
            <div class="organiza-item">
              <p>题干/选项/答案/解析：</p>
              <textarea v-model="item.topic" 
              placeholder="【1】What does the teacher imply when shesays, “But I wasn't the only one”?
(A) Other people came to the picnic, too.
(B) Many people oyed the boy's cake.
(C) Many peopit cakes to thepicnic.
(D) She brought additional items to share.
答案：C
解析：解析


【2】What was the boy’s mother afraid of?
(A) That people would not like the cake
(B) That the cake would not be big enough
(C) That she would not enjoy herself at thepicnic
(D) That she would not have time to makethe cake
答案：B
解析：解析


12、What does the teacher ask the boy todo?
(A) Show her how to bake the cake
(B)Bring her the recipe for the cake
(C) Thank his mother for baking the cake
(D) Invite his mother to the music clubpicnic
答案：D
解析：解析
"></textarea>
            </div>
            <div class="organiza-item">
              <p>听力文本：</p>
              <textarea v-model="item.content" 
                placeholder=""></textarea>
            </div>
          </div>
        </div>
        <div class="btnBox">
          <button class="btn btn-add" @click="addTopicSub">添加题目</button>
          <button class="btn btn-sub" @click="topicSub">确定</button>
          <button class="btn btn-close" @click="topicHide">取消</button>
        </div>
      </div>
      <div class="organiza-txt" v-else>
        <div class="organiza-form ">
          <div class="organiza-list" v-for="(item,index) in addObj.topics" :key="(index+1)">
            <div class="organiza-item">
              <p>题目{{(index+1)}}</p>
              <!-- <input type="text" v-model="item.topic"> -->
              <button class="btn btn-remove" @click="removeTopic(item,index)">删除</button>
            </div>
            <div class="organiza-item">
              <p>提示语：</p>
              <input type="text" v-model="item.prompt" 
              placeholder="例如：
Questions 1-4 refer to the following announcement.">
            </div>
            <div class="organiza-item">
              <p>阅读素材：</p>
              <!-- <Editor v-model="item.content"/> -->
              <myEditor @input="sourceInput" @imgUpload="imgUpload" :value="item.content" :index="index" @click="sourceClick(index)"/>
            </div>
            <div class="organiza-item">
              <p>题干/选项/题干/选项/答案/解析：</p>
              <textarea v-model="item.topic" 
              placeholder="例如：【1】The environmental club is holding（）next Monday at 3 PM. in the
(A) a bake sale
(B) a bake sale is
(C) and a bake sale
(D) that a bake sale
答案：C
解析：解析


【2】hallway outside of the cafeteria. All the money（）will go to the
(A) raised
(B) raising
(C) to raise
(D)was raised
答案：C
解析：解析


【3】International Nature Foundation,（）organization that protects endangered
(A) either
(B) what
(C) any
(D)an
答案：C
解析：解析


【4】animals. The sale will（）delicious cookies, cupcakes, muffins, and more.
(A) save
(B) select
(C)feature
(D)purchase
答案：C
解析：解析
"></textarea>
            </div>
          </div>
        </div>
        <div class="btnBox">
          <button class="btn btn-add" @click="addTopicSub">添加题目</button>
          <button class="btn btn-sub" @click="topicSub">确定</button>
          <button class="btn btn-close" @click="topicHide">取消</button>
        </div>
      </div>
    </div>

    <!-- 列表 -->
    <div class="content " v-else>
      <myHeader></myHeader>
      <div class="searchBox">
        <div class="search-item">
          <p>题型：</p>
          <select v-model="obj.model_id">
            <option value="">请选择</option>
            <option :value="item.model_id" v-for="item in statusList" v-bind:key="item.model_id">{{item.title}}</option>
          </select>
        </div>
        <div class="btnBox">
          <button class="btn btn-search" @click="searchSub">搜索</button>
          <button class="btn btn-reset" @click="resetSub">重置</button>
        </div>
      </div>
      <div class="organiza-txt">
        <div class="organiza-title clear">
          <p>类型</p>
          <div class="btnBox">
            <button class="btn btn-add" @click="addShow">添加题目</button>
          </div>
        </div>
        <div class="organiza-list">
          <div class="titleList">
            <p v-for="item in titleList" v-bind:key="item.id">{{item.title}}</p>
          </div>
          <div class="dataList">
            <div class="listItem" v-for="(item,index) in dataList" v-bind:key="(index+1)">
              <p :title="(index+1)">{{(index+1)}}</p>
              <p :title="item.title">{{item.title}}</p>
              <p :title="item.topic_num+'/'+item.num">{{item.topic_num}}/{{item.num}}</p>
              <p style="color:#FF7543;">
                <span @click="labelShow(item)">
                  标签
                </span>
                <span @click="audioShow(item)">
                  上传音频
                </span>
                <span @click="directionsShow(item)">
                  上传案例
                </span>
                <span @click="lookList(item)">
                  查看题库
                </span>
              </p>
            </div>
          </div>
          <div class="block pageBox clear">
            <el-pagination
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page.sync="obj.page"
              :page-size="1"
              layout="prev, pager, next, jumper"
              :total="totalPage">
            </el-pagination> 
          </div>
        </div>
      </div>
    </div>

    <!-- 添加or编辑提示框 -->
    <div class="msgBox tipsBox" v-if="showType">
      <div class="contv">
        <p class="title">选择题型</p>
        <form>
          <div class="write-txt">
            <p>题型：</p>
            <select v-model="addObj.model_id" @change="selectSub($event)">
              <option value="">请选择</option>
              <option :value="item.model_id" v-for="item in statusList" v-bind:key="item.model_id">{{item.title}}</option>
            </select>
          </div>
        </form>
        <div class="btnBox">
          <button class="btn btn-sub" @click="addSub">确认</button>
          <button class="btn btn-close" @click="closeSub('add')">取消</button>
        </div>
      </div>
    </div>

    <!-- 标签 -->
    <div class="msgBox tipsBox" v-if="labelType">
      <div class="contv">
        <p class="title">添加题型标签</p>
        <form>
          <div class="write-txt">
            <p>题型标签：</p>
            <input type="text" v-model="buildObj.content">
          </div>
        </form>
        <div class="btnBox">
          <button class="btn btn-sub" @click="labelSub">确认</button>
          <button class="btn btn-close" @click="closeSub('label')">取消</button>
        </div>
      </div>
    </div>

    <!-- 音频 -->
    <div class="msgBox tipsBox uploadBox" v-if="audioType" v-loading="loading" :element-loading-text="loadTxt">
      <div class="contv">
        <p class="title">请上传音频</p>
        <form>
          <div class="form-txt">
              <div class="txt">
                <div class="upload">
                  <!-- <el-upload
                    :action="url+'/ent/Upload/uploadFile'"
                    list-type="picture-card"
                    :on-preview="handlePictureCardPreview"
                    :before-upload="handleBefore"
                    :on-success="handleSuccess"
                    :limit=1
                    :on-remove="handleRemove">
                    <i class="el-icon-plus"></i>
                  </el-upload> -->
                  <el-upload
                    :action="'https://upload.qiniup.com'"
                    :data="uploadObj" 
                    list-type="picture-card"
                    :before-upload="beforeUploadImg"
                    :on-success="handleSuccessImg"
                    :on-progress="handleProgressImg"
                    :on-remove="handleRemoveImg">
                    <i class="el-icon-plus"></i>
                  </el-upload>
                  <audio :src="'https://pic.bi-rong.com/'+uploadUrl" controls v-if="uploadUrl"></audio>
                </div>
              </div>
            </div>
        </form>
        <div class="btnBox">
          <button class="btn btn-sub" @click="audioSub">确认</button>
          <button class="btn btn-close" @click="closeSub('audio')">取消</button>
        </div>
      </div>
    </div>

    <!-- 案例 -->
    <div class="msgBox tipsBox uploadBox" v-if="directionsType" v-loading="loading" :element-loading-text="loadTxt">
      <div class="contv">
        <p class="title">请上传案例</p>
        <form>
          <div class="form-txt">
              <div class="txt">
                <div class="img" @mouseenter="imgShow('ExerSet')" @mouseleave="imgHide('ExerSet')">
                  <img :src="'https://pic.bi-rong.com/'+uploadUrl" alt="">
                  <!-- <div class="hover" v-if="imgType">
                    <i class="el-icon-delete" @click="imgRemove('ExerSet')"></i>
                  </div> -->
                </div>
                <div class="upload">
                  <!-- <el-upload
                    :action="url+'/ent/Upload/uploadFile'"
                    list-type="picture-card"
                    :on-preview="handlePictureCardPreview"
                    :before-upload="handleBefore"
                    :on-success="handleSuccess"
                    :limit=1
                    :on-remove="handleRemove">
                    <i class="el-icon-plus"></i>
                  </el-upload> -->
                  <el-upload
                    :action="'https://upload.qiniup.com'"
                    :data="uploadObj" 
                    list-type="picture-card"
                    :before-upload="beforeUploadAudio"
                    :on-success="handleSuccessAudio"
                    :on-progress="handleProgressAudio"
                    :on-remove="handleRemoveImg">
                    <i class="el-icon-plus"></i>
                  </el-upload>
                  <el-dialog :visible.sync="dialogVisible">
                    <img width="100%" :src="'https://pic.bi-rong.com/'+uploadUrl" alt="">
                  </el-dialog>
                </div>
              </div>
            </div>
        </form>
        <div class="btnBox">
          <button class="btn btn-sub" @click="directionsSub">确认</button>
          <button class="btn btn-close" @click="closeSub('directions')">取消</button>
        </div>
      </div>
    </div>

  </div>
  
</template>

<script>
import navBox from './../components/comment/nav.vue';
import myHeader from './../components/comment/myHeader.vue';
import Editor from './../components/comment/editor'
import myEditor from './../components/comment/wangeditor.vue'
import { getSubjectList,getTopicModel,setTopicModel,addTopic,getUploadToken } from "@/assets/js/api";
export default {
  name: "exam",
  data() {
    return {
      navId:'1',
      childrenID:'1-2',
      titleList:[
        {id:1,title:'序号'},
        {id:2,title:'题型'},
        {id:3,title:'题目数量'},
        {id:4,title:'操作'},
      ],
      dataList:[],
      showType:'',
      token:'',
      obj:{
        page:1,
        rows:10,
        tid:'',
        model_id:''
      },
      addObj:{
        tid:'',
        model_id:'',
        type:1,
        topics:[
          {topic:'',content:''},
        ]
      },
      totalPage:0,
      userData:{
        authority:[],
      },
      statusList:[
        // {id:9,title:'全部'},
        // {id:1,title:'听力'},
        // {id:3,title:'语言应用'},
        // {id:2,title:'阅读理解'},
      ],

      uploadUrl:'',
      imgType:false,
      url:'',
      dialogVisible:false,
      headID:1,
      model_id:'',
      topicType:false,
      audioType:false,
      buildObj:{
        model_id:''
      },
      labelType:false,
      directionsType:false,
      topiclistType:false,
      loading:false,
      uploadObj:{
        token:'',
        key:'',
      },
      loadTxt:'',
      editorContent:'ddddd'
    };
  },
  components: {
    navBox,
    myHeader,
    Editor,
    myEditor
  },
  mounted(){
    this.userData = this.$refs.navBox.userData
    this.url = this.$refs.navBox.url;
    this.token =this.userData.token;
    this.obj.tid = this.addObj.tid = this.$route.query.tid;
    this.getList();
    this.getToken();
    window.addEventListener('popstate', function (event) {
      // 在这里执行刷新页面的动作
      location.reload(true);
    });
  },
  methods: {
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
    },
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
      this.getList();
    },

    getToken(){
      getUploadToken(this.token).then((res)=>{
        var data = res.data;
        if(data.code == 200){
          this.uploadObj.token = data.data.token
        }
      })
    },

    // 取消
    closeSub(type){
      if(type == 'add'){
        this.showType = false;
      } else if(type == 'directions'){
        this.directionsType = false;
        this.uploadUrl = '';
      } else if(type == 'audio'){
        this.audioType = false;
        this.uploadUrl = '';
      } else if(type == 'label'){
        this.labelType = false;
      }
    },

    // 确认添加or编辑
    addSub(){
      var that = this;
      this.showType = '';
      this.lookTopic()
    },

    // 搜索
    searchSub(){
      this.obj.page = 1;
      this.dataList = [];
      this.getList();
    },

    // 重置
    resetSub(){
      this.obj.page = 1;
      if(this.obj.title){
        delete this.obj.title;
      };
      this.dataList = [];
      this.getList();
    },

    getList(){
      var that = this;
      getTopicModel({tid:this.obj.tid},this.token).then((res)=>{
        var data = res.data;
        if(data.code == 200){
          that.statusList = data.data;
          that.dataList = data.data;
          if(data.data.length > 0){
            that.obj.model_id = data.data[0].model_id;
          }
          // that.getList();
        } else {
          that.$message(data.msg);
        }
      })
    },

    addShow(){
      this.showType = 'add';
    },

    editShow(e){
      this.showType = 'edit';
      
    },

    imgShow(){
      this.imgType = true;
    },

    imgHide(){
      this.imgType = false;
    },

    imgRemove(){
      this.uploadUrl = '';
    },

    handleRemove(file, fileList) {
      console.log(file, fileList,'remove');
      this.uploadUrl = '';
    },
    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
    },
    handleBefore(){
      this.loading = true;
    },
    beforeUploadImg(file){
      this.loading = true;
      this.uploadObj.key = file.uid + file.name; // key为上传后文件名 必填
    },
    beforeUploadAudio(file){
      this.loading = true;
      this.uploadObj.key = file.uid + file.name; // key为上传后文件名 必填
    },
    handleSuccessImg(response, file, fileList){
      this.uploadUrl = response.key;
      this.loading = false;
      this.uploadObj.key = '';
    },
    handleSuccessAudio(response, file, fileList){
      this.uploadUrl = response.key;
      this.loading = false;
      this.uploadObj.key = '';
    },
    handleSuccess(response, file, fileList){
      console.log(response)
      this.uploadUrl = response.data.src;
      this.loading = false;
    },
    handleProgressImg(event, file, fileList) {
      this.loadTxt = '已上传' + file.percentage.toFixed(0) + '%';
    },
    handleProgressAudio(event, file, fileList){
      this.loadTxt = '已上传' + file.percentage.toFixed(0) + '%';
    },
    handleRemoveImg(){
      this.uploadUrl = '';
    },


    lookTopic(e){
      console.log(this.addObj)
      this.topicType = true;
    },

    headSub(i){
      var that = this;
      
      this.$confirm('请确定当前编辑是否已经提交,否则此次数据将清空, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        that.headID = this.addObj.type = i;
        if(i == 1){
          that.addObj.topics=[{topic:'',content:'',prompt:''}];
        } else {
          that.addObj.topics=[{topic:'',content:'',prompt:''}];
        };
      }).catch(() => {
                 
      });
    },

    topicModel(type){
      var that = this;
      setTopicModel(this.buildObj,this.token).then((res)=>{
        var data = res.data;
        if(data.code == 200){
          that.$message('成功!');
          that.audioType=false;
          that.labelType=false;
          that.directionsType=false;
          that.buildObj = {
           model_id:''
          };
          that.uploadUrl = '';
          that.resetSub();
        } else {
          that.$message(data.msg);
        }
      })
    },

    audioShow(e){
      this.audioType = true;
      if(e.video){
        this.uploadUrl = e.video;
      }
      this.buildObj.model_id = e.model_id;
    },

    audioSub(){
      this.buildObj.video = this.uploadUrl;
      this.topicModel();
    },

    labelShow(e){
      this.labelType = true;
      this.buildObj.model_id = e.model_id;
      this.buildObj.content = e.content;
    },

    labelSub(){
      this.topicModel();
    },

    directionsShow(e){
      this.directionsType = true;
      if(e.directions){
        this.uploadUrl = e.directions;
      }
      this.buildObj.model_id = e.model_id;
    },

    directionsSub(){
      this.buildObj.directions = this.uploadUrl;
      this.topicModel();
    },

    addTopicSub(){
      var that = this;
      this.addObj.type = this.headID;
      if(this.headID == 1){
        that.addObj.topics.push({topic:'',content:'',prompt:''});
      } else {
        that.addObj.topics.push({topic:'',content:'',prompt:''});
      }
      console.log(this.addObj);
    },

    removeTopic(e,i){
      var that = this;
      this.addObj.topics.splice(i,1);
    },

    topicSub(){
      var that = this;
      console.log(this.addObj);
      addTopic(this.addObj,this.token).then((res)=>{
        var data = res.data;
        if(data.code == 200){
          that.$message('成功!');
          that.topicType = false;
          that.resetSub();
        } else {
          that.$message(data.msg);
        }
      })
    },

    topicHide(){
      var that = this;
      that.topicType = false;
    },

    lookList(e){
      this.$router.push('/bank?tid='+this.obj.tid + '&model_id='+e.model_id+'&is_hearing='+e.is_hearing);
    },

    selectSub(e){
      var that = this;
      var val = e.target.value;
      this.statusList.forEach(function(item,index){
        if(val == item.model_id){
          if(item.video){
            that.topiclistType = true
          } else {
            that.topiclistType = false;
            that.headID = 2;
            delete that.addObj.type;
          }
        }
      })
    },

    // hChangeData(editDataHtml){
    //   // 获取最新的html数据
    //   this.content = editDataHtml
    //   console.log(this.content)
    // },
    // hUploadImg(file,insertFn){
    //   console.log(file)
    //   // 插入图片，调接口返回图片url,通过插入conteng
    //   let imgUrl = 'https://img1.baidu.com/it/u=608404415,1639465523&fm=253&fmt=auto&app=120&f=JPEG?w=1280&h=800'
    //   insertFn(imgUrl);

    //   // 设置只读
    //   this.readOnlys = true;
    // },

    sourceClick(i){
      console.log(i,'==i==')
    },

    sourceInput(value,index) {
      this.addObj.topics[index].content = value;
    },

    imgUpload(type){
      console.log(type,'==type==')
    }
  },
};
</script>
<style scoped>
.topicBox .organiza-list{
  margin-top: 30px;
  font-size: 0;
  height: auto;
}

.dataList .listItem p,
.organiza-list p{
  width: 25%;
}

.uploadBox .txt{
  height: auto;
}

.tipsBox.uploadBox .txt .img{
  width: 200px;
  display: block;
  margin: 0 auto;
}

.tipsBox.uploadBox .txt .img img{
  width: 100%;
}

.topicBox .organiza-title p {
  margin-right: 20px;
}

.topicBox .organiza-title p.select {
    font-size: 20px;
    font-weight: 700;
    border-bottom: 5px solid #4c7efb;
}

.topicBox .organiza-title p::before {
  display: none;
}

.topicBox .organiza-item input,
.topicBox .organiza-item p,
.topicBox .organiza-item textarea{
  display: inline-block;
  vertical-align: top;
  padding: 21px 30px;
  box-sizing: border-box;
  width: auto;
}

.topicBox .organiza-item input,
.topicBox .organiza-item textarea{
  width: 40%;
  height: 200px;
  border-radius: 5px;
  border: solid 1px #ccc;
  margin: 21px 0;
  font-size: 18px;
}

.topicBox .organiza-item input{
  height: 20px;
  padding: 20px 10px;
  margin: 10px 0;
}

.topicBox .organiza-item .btn-remove{
  background-color: #00D4BF;
  color: #fff;
  padding: 5px 10px;
  border-radius: 5px;
  display: inline-block;
  margin: 15px 0 0 20px;
}

.topicBox .btnBox{
  font-size: 0;
  margin-top: 20px;
}

.topicBox .btnBox .btn{
  display: inline-block;
  vertical-align: top;
  padding: 10px 20px;
  background-color: #457AFF;
  color: #fff;
  border-radius: 10px;
  margin-right: 20px;
}

.topicBox .btnBox .btn.btn-close{
  background-color: #CBCBCB;
}

.organiza-form{
  height: 100%;
  overflow-y: auto;
  overflow-x: hidden;
}

.organiza-item{
  margin-top: 30px;
}


</style>



// WEBPACK FOOTER //
// src/exam/topicAdmin.vue